import React from 'react';
import ModalContainer from 'react-modal-promise';
import { Link } from 'react-router-dom';

import { transformErrorResponse } from 'helpers/errors';
import { deletePaymentMethod } from 'api';
import FormError from '../FormError';
import UserPaymentMethodDeleteModal from './UserPaymentMethodDeleteModal';
import { can, permActions } from 'permissions';

export default class UserPaymentMethodECheckList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  async deletePaymentMethod(userId, id) {
    try {
      const { status } = await deletePaymentMethod(userId, id);

      if ([200, 201].includes(status)) {
        this.setState({ success: true });
      }
    } catch ({ response }) {
      const error = transformErrorResponse(response.data);
      this.setState({ error });
    }
  }

  async handleOpenModal(lastFour, id, userId) {
    this.setState({ isModalOpen: true });
    const confirmResult = await UserPaymentMethodDeleteModal({
      open: this.state.isModalOpen,
      lastFour,
    });

    if (confirmResult) {
      await this.deletePaymentMethod(userId, id);
      this.fetchPaymentMethods();
    }

    this.setState({ isModalOpen: false });
  }

  fetchPaymentMethods() {
    const { fetchUserPaymentMethods, user, page } = this.props;
    if (user) {
      fetchUserPaymentMethods(user.id, page);
    }
  }

  render() {
    const { list, user, loggedInUser } = this.props;

    const showDelete = can(loggedInUser, permActions.DELETE_PAYMENT_METHOD);

    return (
      <div>
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Account Name</th>
              <th>Bank Name</th>
              <th>Account Number</th>
              <th>Is Default?</th>
              <th></th>
              {showDelete && <th></th>}
            </tr>
          </thead>
          <tbody>
            {list.length > 0 &&
              list.map((card) => (
                <tr key={card.id}>
                  <td>{card.id}</td>
                  <td>{card.name_on_account}</td>
                  <td>{card.bank_name}</td>
                  <td>{card.account_number}</td>
                  <td>{card.is_default ? 'Yes' : 'No'}</td>
                  <td>
                    <Link
                      to={`/users/${user.id}/payment-methods/${card.id}/view`}
                    >
                      View
                    </Link>
                  </td>
                  {showDelete && (
                    <td>
                      <button
                        className="btn btn-default"
                        onClick={() => {
                          this.handleOpenModal(
                            card.account_number,
                            card.id,
                            user.id,
                          );
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            {list.length === 0 ? (
              <tr>
                <td colSpan="7">No payment methods yet</td>
              </tr>
            ) : null}
          </tbody>
        </table>
        <ModalContainer />
        {this.state.error ? <FormError error={this.state.error} /> : null}
        {this.state.success ? (
          <div className="text-success">Payment method was deleted.</div>
        ) : null}
      </div>
    );
  }
}
